(() => {
  const inlineConfig = window.privateSaleSearchspringDiscount;

  function storedEligibility() {
    let stored;
    try {
      stored = JSON.parse(localStorage.getItem('privateSaleEligibility'));
    } catch (e) {
      return null;
    }
    if (!stored || !stored.percent || !Array.isArray(stored.handles) || !stored.handles.length) return null;
    return stored;
  }

  const PROCESSED_ATTR = 'data-private-sale-adjusted';

  function discountedPrice(base, percent) {
    // Match Shopify's own discount math: floor the discount amount in cents, don't round the final price.
    const baseCents = Math.round(base * 100);
    const discountCents = Math.floor((baseCents * percent) / 100);
    return ((baseCents - discountCents) / 100).toFixed(2);
  }

  function cardHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function processCard(card, percent, handles) {
    // handles is only set when there's no page-level collection config (e.g. the search page,
    // where results span unrelated products) -- restrict to the eligible handles in that case.
    if (handles && !handles.includes(cardHandle(card))) return;

    const pricing = card.querySelector('.ss__result__details__pricing');
    if (!pricing) return;

    const priceSpans = pricing.querySelectorAll('.ss__price:not(.ss__price--strike)');
    const currentSpan = priceSpans[priceSpans.length - 1];
    if (!currentSpan || currentSpan.hasAttribute(PROCESSED_ATTR)) return;

    const valueSpan = currentSpan.querySelector('.ss__price__value');
    if (!valueSpan) return;

    const basePrice = parseFloat(valueSpan.textContent);
    if (isNaN(basePrice)) return;

    const discounted = discountedPrice(basePrice, percent);
    const alreadyOnSale = !!pricing.querySelector('.ss__price--strike');

    currentSpan.setAttribute(PROCESSED_ATTR, 'true');

    if (!alreadyOnSale) {
      const strikeClone = currentSpan.cloneNode(true);
      strikeClone.classList.add('ss__price--strike');
      strikeClone.removeAttribute(PROCESSED_ATTR);
      currentSpan.insertAdjacentElement('beforebegin', strikeClone);
    }

    valueSpan.textContent = discounted;
  }

  function debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }

  function processAll() {
    const inlinePercent = inlineConfig && inlineConfig.percent;
    const eligibility = storedEligibility();

    if (inlinePercent) {
      // The locked collection's own results grid -- every card here is part of the sale.
      document.querySelectorAll('#searchspring-content .ss__result').forEach((card) => processCard(card, inlinePercent, null));
    }

    if (eligibility) {
      // Everywhere else Searchspring renders a result card -- other collections, search, and the
      // autocomplete/typeahead dropdown (which mounts its own '.ss__autocomplete' tree outside
      // '#searchspring-content' and isn't scoped to any one collection) -- only eligible handles.
      document.querySelectorAll('.ss__result').forEach((card) => {
        if (inlinePercent && card.closest('#searchspring-content')) return;
        processCard(card, eligibility.percent, eligibility.handles);
      });
    }
  }

  function init() {
    if (!(inlineConfig && inlineConfig.percent) && !storedEligibility()) return;

    processAll();

    const debouncedProcessAll = debounce(processAll, 150);
    const observer = new MutationObserver(debouncedProcessAll);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
